export default __webpack_public_path__ + "static/media/BlackCastleValleyMap.db03d851.jpg";